import hardTrim from './hardTrim';

const trimLower = (str) => hardTrim(str).toLowerCase();

export const searchMilanStores = (milanStores, searchInput) => {
    let foundStores = [];
    const value = trimLower(searchInput).toLowerCase();
    milanStores.forEach((state, s) => {
        if (trimLower(state.name).includes(value)) {
            foundStores.push({
                title: 'Milan Laser ' + state.name,
                url: `/locations/${state.abbreviation.toLowerCase()}`,
            });
        }
        if (state.metros.length !== 0) {
            state.metros.forEach((metro, m) => {
                if (trimLower(metro.name).includes(value)) {
                    const firstStore = metro.stores[0];
                    const metroUrl = firstStore?.urlPath
                        ? firstStore.urlPath.split('/').slice(0, -1).join('/')
                        : `/locations/${state.abbreviation.toLowerCase()}/${metro.pathname}`;

                    foundStores.push({
                        title: 'Milan Laser ' + metro.name,
                        url: metroUrl,
                    });
                }
                if (metro.stores.length !== 0) {
                    metro.stores.forEach((store, x) => {
                        if (
                            trimLower(store.marketingCity).includes(value) ||
                            trimLower(store.addressCity).includes(value) ||
                            trimLower(store.clinicName).includes(value)
                        ) {
                            foundStores.push({
                                title: 'Milan Laser ' + store.marketingCity,
                                url: store.urlPath,
                            });
                        }
                    });
                }
            });
        }
    });
    if (foundStores.length > 0) {
        foundStores.push({
            title: 'Milan Laser Locations',
            url: '/locations/',
        });
    }
    return foundStores;
};
